export default __webpack_public_path__ + "static/media/consumingbulwark.55793f3f.png";